import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { StepType } from 'app/models/workflow-step';
import { Router } from '@angular/router';
import { FormArray, FormGroup } from '@angular/forms';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { StepCompletionSelectorComponent } from '../../step-completion-selector/step-completion-selector.component';

@Component({
  selector: 'app-add-new-step-modal',
  templateUrl: './add-new-step-modal.component.html',
  styleUrls: ['./add-new-step-modal.component.scss']
})
export class AddNewStepModalComponent implements OnInit {
  
  stepCompletion: FormGroup;
  @Output() stepAdded: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('addStepTypeModal', {static: false}) addStepTypeModal: ModalDirective;
  @ViewChild('stepCompletionSelector', {static: false}) stepCompletionSelector: StepCompletionSelectorComponent;

  stepType: string;
  stepCompletionsCount: number;

  constructor(private workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService, private _router: Router) { 
    
  }

  ngOnInit() {
    this.stepType = 'approval';
    this.stepCompletion = null;
    this.stepCompletionsCount = 1;
  }

  show(stepCompletion: FormGroup) {
    this.stepCompletion = stepCompletion;
    this.addStepTypeModal.show();
  }

  onSubmit() {
    let newStepFormGroup: FormGroup;
    
    let existingNextStep: FormGroup = this.stepCompletion.controls['next_step'] as FormGroup;

    switch (this.stepType) {
      case 'approval':
        newStepFormGroup = this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(2, StepType.APPROVAL), this.stepCompletion);
        break;
      case 'review':
        newStepFormGroup = this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(1, StepType.REVIEW), this.stepCompletion);
        break;
      case 'custom':
        newStepFormGroup = this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(this.stepCompletionsCount, StepType.CUSTOM), this.stepCompletion);
        break;
      case 'auto':
        newStepFormGroup = this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(this.stepCompletionsCount, StepType.AUTO), this.stepCompletion);
        break;
    }

    if (existingNextStep && existingNextStep.get('name') && existingNextStep.get('name').value && existingNextStep.get('name').value != '') {
      let attachToStepCompletionIndex = 0;
      let attachToStepCompletion = () => {
        let newStepCompletionFormGroup = <FormGroup>newStepFormGroup.get(`step_completions.${attachToStepCompletionIndex}`);
        newStepCompletionFormGroup.controls['next_step'] = existingNextStep;
        existingNextStep.setParent(newStepCompletionFormGroup);
        newStepCompletionFormGroup.controls['next_step'].updateValueAndValidity();
        this.navigateToEditStep(newStepFormGroup);
      }
      if ((newStepFormGroup.controls['step_completions'] as FormArray).length > 1) {
        this.stepCompletionSelector.show(<FormArray>newStepFormGroup.get('step_completions'), (selectedIndex) => {
          attachToStepCompletionIndex = selectedIndex;
          attachToStepCompletion();
        });
      } else {
        attachToStepCompletion();
      }
    } else {
      this.navigateToEditStep(newStepFormGroup);
    }    
  }

  navigateToEditStep(newStepFormGroup: FormGroup) {
    this.workflowWizardService.currentStep = newStepFormGroup;
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
    this.stepAdded.emit();
    this.stepCompletion = null;
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`);
  }
}
